/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'townsquare.townsquare-tags.tag': 'Remove tag',
  'townsquare.townsquare-tags.tooltip-usage-count': 'Used in {usageCount, plural, one {# place} other {# places}}',
};
